export default __webpack_public_path__ + "static/media/prod-img-4.0cc0335a.webp";